"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (property) {
  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/styled-components/~/inline-style-prefixer/lib/utils/isPrefixedProperty.js
// module id = 1067
// module chunks = 0